import React from 'react';
import {connect} from "react-redux";
import {Container, Grid, GridRow, Menu, Segment} from "semantic-ui-react";
import CancelModal from "./anualOpenEnrollment/cancelModal";
import {currentYear} from "../utils/date";
import axios from "axios";
import {setFooter} from "../actions/footerActions";
import {Responsive} from "./custom-common";
import {BREAKPOINTS} from '../utils/common';

const rightsReservedCopy = `©${currentYear()} Ansel Health, Inc. All Rights Reserved.`;
const baseJoinBrellaUrl = 'https://www.joinansel.com/';
const buildJoinBrellaUrl = (path) => baseJoinBrellaUrl + path;
const privacyPolicyUrl = buildJoinBrellaUrl('privacy-policy');
const termsUrl = buildJoinBrellaUrl('terms');

const mapStateToProps = ({footer, auth, anualOpenEnrollment}, ownProps) => {
    return {
        authToken: auth?.loginInfo?.authToken,
        showCancelAOEFlowModal: anualOpenEnrollment.showCancelAOEFlowModal,
        carrierDisclaimers: footer.carrierDisclaimer?.split('\n') || [],
        ...ownProps
    }
};

const Footer = ({button, showTopFooter, link, hasToDisplayCarrierDisclaimer, carrierDisclaimers,
                    showCancelAOEFlowModal, authToken, dispatch}) => {
    const isLoggedin = authToken || false;

    const hasCarrierDisclaimers = React.useCallback(() => !!carrierDisclaimers.length, [carrierDisclaimers]);

    const displayCarrierDisclaimer = isLoggedin && hasToDisplayCarrierDisclaimer && hasCarrierDisclaimers();

    React.useEffect(() => {
        const fetchFooterData = () => {
            if (hasToDisplayCarrierDisclaimer && !hasCarrierDisclaimers()) {
                axios.post("/api/member/v2/getFooter", null).then(({data}) => { dispatch(setFooter(data)) });
            }
        }
        fetchFooterData();
    }, [hasToDisplayCarrierDisclaimer]);

    return (
        <React.Fragment>
            {showCancelAOEFlowModal && <CancelModal/>}
            <div className="footer">
                {showTopFooter &&
                    <div className={"buttonContainer"}>
                        <Container>
                            <Grid columns={3} verticalAlign={"middle"}>
                                <Grid.Column width={2}/>
                                <Grid.Column>
                                    {button}
                                </Grid.Column>
                                <Grid.Column width={2} textAlign={"left"}>
                                    {!!link && link}
                                </Grid.Column>
                            </Grid>
                        </Container>
                    </div>
                }
                <Responsive minWidth={BREAKPOINTS.DESKTOP}>
                    <Container fluid>
                        <Grid columns={'equal'}>
                            <Grid.Column>
                                <Menu text>
                                    <Menu.Item>
                                        {rightsReservedCopy}
                                    </Menu.Item>
                                </Menu>
                            </Grid.Column>
                            <Grid.Column>
                                <Menu text className={'termsPrivacy'}>
                                    <Menu.Menu position="right">
                                        <Menu.Item as="a" href={termsUrl} target="_blank">
                                            Terms
                                        </Menu.Item>
                                        <Menu.Item as="a" href={privacyPolicyUrl} target="_blank">
                                            Privacy
                                        </Menu.Item>
                                    </Menu.Menu>
                                </Menu>
                            </Grid.Column>
                        </Grid>
                        { displayCarrierDisclaimer &&
                            <GridRow>
                                { carrierDisclaimers?.map((paragraph, index) =>
                                    (<p key={index} className={'carrierDisclaimers'}>{paragraph}</p>))}
                            </GridRow>
                        }
                    </Container>
                </Responsive>
                <Responsive maxWidth={BREAKPOINTS.DESKTOP - 1}>
                    <Segment basic className={'dispositives'}>
                        { displayCarrierDisclaimer &&
                            <p className={"neutral700Text carrierDisclaimers"}>
                                { carrierDisclaimers?.map((paragraph, index) =>
                                    (<React.Fragment key={index}><span>{paragraph}</span><br/></React.Fragment>))
                                }
                            </p>
                        }
                        <p className={"neutral700Text"}>{rightsReservedCopy}</p>
                        <p>
                            <a style={{paddingRight: '1em'}} className={"neutral500Text"} href={privacyPolicyUrl}  target="_blank" rel="noopener noreferrer">
                                <b>Privacy</b>
                            </a>
                            <a className={"neutral500Text"}  href={termsUrl}  target="_blank" rel="noopener noreferrer">
                                <b>Terms</b>
                            </a>
                        </p>
                    </Segment>
                </Responsive>
            </div>
        </React.Fragment>
    )
}

export default connect(mapStateToProps)(Footer);
